import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './CursorIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const CursorIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function CursorIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 19" component={Icon} {...props} />
  );
});
